import { apiClient } from './axios';

import type {
  CreateWorkflowTemplateDto,
  UpdateWorkflowTemplateDto,
  WorkflowTemplate,
} from '@repo/shared-types';

export const workflowTemplatesApi = {
  getAll: async () => {
    const response = await apiClient.get<WorkflowTemplate[]>('/workflow-templates');
    return response.data;
  },

  getOne: async (id: string) => {
    const response = await apiClient.get<WorkflowTemplate>(`/workflow-templates/${id}`);
    return response.data;
  },

  create: async (data: CreateWorkflowTemplateDto) => {
    const response = await apiClient.post<WorkflowTemplate>('/workflow-templates', data);
    return response.data;
  },

  update: async (id: string, data: UpdateWorkflowTemplateDto) => {
    const response = await apiClient.patch<WorkflowTemplate>(`/workflow-templates/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/workflow-templates/${id}`);
  },
};
